<template>
<!-- :style="{'min-height': docHt + 'px'}" -->
  <div class="container">
    <div class="form">
      <h3>设置密码</h3>
      <div class="input-group">
        <div class="group-item">
          <input type="text" placeholder="负责人手机号" v-model="form.phone" @input="onInputPhone" />
          <div class="error-msg" v-if="!isCheckPhone && form.phone">请输入正确的手机号</div>
        </div>
        <div class="group-item group-item-password">
          <input type="text" placeholder="请输入密码" v-model="form.password" @input="onInputPassword" minlength="6" maxlength="50" />
          <div class="error-msg" v-if="!isCheckPassword && form.password">密码不得小于6位</div>
        </div>
        <div class="group-item-link">
          <router-link :to="{path: '/', query: { 'phone': form.phone}}">通过手机号验证码登录</router-link>
        </div>
      </div>
      
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="submit-btn disabled-btn" v-if="!form.phone || !form.password || !isCheckPhone || !isCheckPassword">下一步</div>
      <div class="submit-btn" @click="onSubmit" v-else>下一步</div>
    </div>
    <ContactBtn />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  name: 'login',
  data() {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      token: getToken(),
      sendCode: false,
      form: {
        phone: undefined,
        password: undefined
      },
      isCheckPhone: false,
      isCheckPassword: false,
      seconds: '',
      count: 60,
      timer: null,
    };
  },
  created() {
    if(this.$route.query.phone) {
      this.form.phone = this.$route.query.phone || undefined;
      this.isCheckPhone = this.checkPhone(this.form.phone);
    }
  },
  methods: {
    onInputPhone(val) {
      this.form.phone = this.trimSpecial(this.form.phone);
      this.isCheckPhone = this.checkPhone(this.form.phone);
    },
    onInputPassword() {
      this.isCheckPassword = this.form.password.length < 6 ? false : true;
    },
    onSubmit() {
      this.$store.dispatch("Login", this.form).then((res) => {
      }).catch((err) => {
        this.$toast(err.msg)
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
  }
  .form{
    width: 100%;
    margin-top: 3rem;
    h3{
      line-height: 1;
      font-size: 1.2rem;
      color: #222;
      text-align: center;
    }
    .input-group{
      width: 15rem;
      margin: 4.25rem auto 0;
    }
    .group-item{
      width: 15rem;
      height: 2.8rem;
      margin-bottom: 1.2rem;
      input{
        width: 13.5rem;
        height: 2.6rem;
        padding: 0 .65rem;
        border-radius: .5rem;
        border: .1rem solid #ddd;
        @include flex();
        font-size: .8rem;
        color: #222;
        &::-webkit-input-placeholder {
            font-size: .8rem;
            color: #ccc;
        }
        :-moz-placeholder {
            font-size: .8rem;
            color: #ccc;
        }
        ::-moz-placeholder {
            font-size: .8rem;
            color: #ccc;
        }
        &[type="text"]:focus{ 
          border: .1rem solid $base-color;
        }
      }
    }
    .group-item-password{
      margin-bottom: .5rem;
    }
    .group-item-link{
      line-height: 1.4;
      text-align: right;
      a{
        font-size: .6rem;
        color: #999;
      }
    }
  }
  .error-msg{
    font-size: .65rem;
    color: #FF4743;
  }
}
@media screen and (min-width:750px){
  .container{
    padding-top: 1px;
  }
  .form{
    width: 100%;
    margin-top: 60px;
    h3{
      line-height: 1;
      font-size: 24px;
      color: #222;
      text-align: center;
    }
    .input-group{
      width: 300px;
      margin: 85px auto 0;
    }
    .group-item{
      width: 300px;
      height: 56px;
      margin-bottom: 24px;
      input{
        width: 270px;
        height: 52px;
        padding: 0 13px;
        border-radius: 10px;
        border: 1px solid #ddd;
        @include flex();
        font-size: 16px;
        color: #222;
        &::-webkit-input-placeholder {
            font-size: 16px;
            color: #ccc;
        }
        :-moz-placeholder {
            font-size: 16px;
            color: #ccc;
        }
        ::-moz-placeholder {
            font-size: 16px;
            color: #ccc;
        }
        &[type="text"]:focus{ 
          border: 2px solid $base-color;
        }
      }
    }
    .group-item-password{
      margin-bottom: 10px;
    }
    .group-item-link{
      line-height: 1.4;
      text-align: right;
      a{
        font-size: 12px;
        color: #999;
      }
    }
  }
  .error-msg{
    font-size: 13px;
    color: #FF4743;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/set-password.vue